import { GET_CABRIDE_REQUESTED, GET_DASHBOARDFEEDBACK_REQUESTED, GET_OURCAR_REQUESTED, GET_RIDEACCEPT_REQUESTED, GET_TOPDRIVER_REQUESTED, GET_TOPSUBVENDOR_REQUESTED, GET_TOPVENDOR_REQUESTED } from "resources/actionTypes";


export function getOurCar(data) {
  return {
    type: GET_OURCAR_REQUESTED,
    payload:data
  };
}

export function getCabRide(data) {
  return {
    type: GET_CABRIDE_REQUESTED,
    payload:data
  };
}

export function getTopVendor(data) {
  return {
    type: GET_TOPVENDOR_REQUESTED,
    payload:data
  };
}

export function getTopSubVendor(data) {
  return {
    type: GET_TOPSUBVENDOR_REQUESTED,
    payload:data
  };
}

export function getTopDriver(data) {
  return {
    type: GET_TOPDRIVER_REQUESTED,
    payload:data
  };
}

export function getRideAccept(data) {
  return {
    type: GET_RIDEACCEPT_REQUESTED,
    payload:data
  };
}

export function getDashboardFeedback(data) {
  return {
    type: GET_DASHBOARDFEEDBACK_REQUESTED,
    payload:data
  };
}